exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".modal-container[data-v-c14eb8ca] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

